import {inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {Observable} from 'rxjs';

import * as APIM from '@common/utils/dist/models/api-messages.js';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {DeviceConfigs} from '@common/ble/dist/index.js';

import {Action} from '@actions/action';
import {
  CreateSectionAction,
  SectionTarget,
} from '@actions/create-section.action';
import {collectionPreconfig} from '@utils/collection-preconfig-utils';

export interface AddCollectDataSectionInput {
  title: string;
  setup: APIM.AgentCollectionSetup;
}

/**
 * Adds a collect data card proposed by the lesson chat to the end of the current lesson,
 * preconfigured (dCSP) for its device, graphs, displays and sample rate.
 */
@Injectable({providedIn: 'root'})
export class AddCollectDataSectionToLessonAction implements Action<
  AddCollectDataSectionInput,
  PL2.AnySectionEntry
> {
  private _createSectionAction = inject(CreateSectionAction);
  private _translate = inject(TranslateService);

  execute(
    input: AddCollectDataSectionInput,
    target?: SectionTarget,
  ): Observable<PL2.AnySectionEntry> {
    const deviceConfig = DeviceConfigs.find(
      (d) => d.name === input.setup.deviceName,
    );
    if (!deviceConfig) {
      throw new Error(`Unknown device "${input.setup.deviceName}"`);
    }
    return this._createSectionAction.execute({
      partialEntry: {
        n:
          input.title || this._translate.instant('live-trial-section.nDefault'),
        dCSP: collectionPreconfig(deviceConfig, input.setup),
      },
      entryType: PL2.EntryType.CollectDataSection,
      index: Number.MAX_SAFE_INTEGER,
      scope: PL2.SectionScope.Group,
      target,
    });
  }
}
